import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td, Link } from "@chakra-ui/react";

import Paragraph from "../ui/common/Paragraph";
import Section from "../ui/common/Section";

const items = [
  {
    title: "",
    text: (
      <Paragraph>
        <i>microPublication</i> journals work directly with community supporting
        knowledgebases during the submission process. By submitting research for
        publication in *microPublication* journals, authors agree to adhere to
        nomenclature and experimental standards set by their community database.
        In addition, authors agree to have relevant data sent, stored, and
        curated in these databases and made available to the public. Where a
        specific community database is not available, we will work with the
        authors to ensure their data is stored and available in an appropriate
        repository. Further, upon publication, authors agree to make materials,
        data, code, and associated protocols promptly available when requested
        by readers.
      </Paragraph>
    ),
  },
  {
    title: "Collaborating Knowledgebases",
    text: (
      <Table>
        <Thead>
          <Tr>
            <Th>
              <b>Authoritative Data Repository</b>
            </Th>
            <Th>
              <b>Article Datafocus</b>
            </Th>
            <Th>
              <b>Copyright and licensing</b>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>
              <Link isExternal href="https://wormbase.org">
                WormBase
              </Link>
            </Td>
            <Td>
              <i>Caenorhabditis</i> research
            </Td>
            <Td>
              WormBase is copyright © 1999-2017 California Institute of
              Technology, European Bioinformatics Institute, Ontario Institute
              for Cancer Research, Washington University at St. Louis, and The
              Wellcome Trust Sanger Institute.Permission to use the information
              contained in this database was given by the researchers/institutes
              who contributed or published the information. Users of the
              database are solely responsible for compliance with any copyright
              restrictions, including those applying to the author abstracts.
              Documents from this server are provided “AS-IS” without any
              warranty, expressed, or implied.
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://xenbase.org">
                Xenbase
              </Link>
            </Td>
            <Td>
              <i>Xenopus</i> research
            </Td>
            <Td>
              The copyright of all Xenbase content, including, but not limited
              to, images, movies, video tutorials, graphs, diagrams and text,
              belongs to Xenbase or with the individuals who submitted the data
              or the publisher and/or authors of the work.Images on Xenbase ®
              from copyrighted publications are used with permission of the
              publisher and/or copyright holder. Xenbase users <b>must</b>{" "}
              independently seek permission to reuse copyrighted images in their
              own work.
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://flybase.org">
                Flybase
              </Link>
            </Td>
            <Td>
              <i>Drosophila</i> research
            </Td>
            <Td>
              Copyright ©1993-2006 by The Genetics Society of America. All
              Rights Reserved.
              <br />
              FlyBase comprises a series of electronic documents and information
              processing software, the reference copy of which currently resides
              at the Internet address ftp.flybase.org/flybase/. This publication
              may be copied for non-commercial, scientific uses by individuals
              or organizations (including for-profit organizations). FlyBase is
              freely distributed to the scientific community on the
              understanding that it will not be used for commercial gain by any
              organization. Any commercial use of this publication, or any parts
              thereof, is expressly prohibited without permission in writing
              from the FlyBase consortium. Certain portions of FlyBase are
              copyrighted separately. This notice does not invalidate any prior
              copyright pertaining to portions of FlyBase. Warranty FlyBase and
              the Genetics Society of America make no warranty of any kind with
              respect to the subject matter included herein. FlyBase and the
              Genetics Society of America specifically disclaim all warranties,
              expressed, implied or otherwise, including without limitation, all
              warranties of merchantability, fitness for a particular purpose,
              or non-infringement.The information contained in this publication
              is subject to change without notice. By viewing or using this
              information the user agrees that in no event shall FlyBase or the
              Genetics Society of America be liable for any special, incidental,
              indirect, or consequential damages of any kind, or any damages
              whatsoever, whether or not advised of the possibility of damage,
              arising out of or in connection with the use or performance of
              this information. Disclaimer:
              <br />
              Information in FlyBase is curated from the scientific literature,
              including unrefereed sources such as abstracts, reviews, and
              personal communications. With the partial exception of map data,
              statements of fact are not vetted by FlyBase. Users should
              remember that published information is not always correct
              information and are encouraged to use FlyBase as a guide to the
              literature rather than as a substitute for it.
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://yeastgenome.org">
                SGD
              </Link>
            </Td>
            <Td>
              <i>Saccharomyces</i> research
            </Td>
            <Td>
              Saccharomyces Genome Database is copyright © 1993-2019 Stanford
              University. The information is provided under the CC BY 4.0
              license and is free for reuse and redistribution but requiring
              attribution. SGD is provided “AS-IS” without any warranty,
              expressed, or implied.
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://arabidopsis.org">
                TAIR
              </Link>
            </Td>
            <Td>
              <i>Arabidopsis</i> research
            </Td>
            <Td>
              The Arabidopsis Information Resource (TAIR) maintains a{" "}
              <Link
                isExternal
                href="http://www.arabidopsis.org/search/ERwin/Tair.htm"
              >
                database
              </Link>{" "}
              of genetic and{" "}
              <Link
                isExternal
                href="http://www.arabidopsis.org/about/datasources.jsp"
              >
                molecular biology data
              </Link>{" "}
              for the model higher plant{" "}
              <Link
                isExternal
                href="http://www.arabidopsis.org/portals/education/aboutarabidopsis.jsp"
              >
                Arabidopsis thaliana
              </Link>
              . Data available from TAIR may include the complete genome
              sequence along with gene structure, gene product information, gene
              expression, DNA and seed stocks, genome maps, genetic and physical
              markers, publications, and information about the Arabidopsis
              research community (collectively, the “Data”). Gene product
              function data is obtained from published research literature,
              community data submissions and computational prediction methods.
              <br />
              <Link isExternal href="http://www.phoenixbioinformatics.org/">
                Phoenix Bioinformatics Corporation
              </Link>{" "}
              (“Phoenix”) owns the database and compilations which make up the
              TAIR materials (“Materials”) under property rights and applicable
              copyright laws. Phoenix manages the data and Materials and
              provides them in a number of machine-readable and human-readable
              formats on its web site, ftp site, or through its web services
              (“API”). Collectively, the Data, Materials, and API will be
              referred to as the “Service.”
              <br />
              Please refer to our{" "}
              <Link
                isExternal
                href="https://www.arabidopsis.org/doc/about/tair_terms_of_use/417"
              >
                Terms of Service
              </Link>{" "}
              for detailed information about data use and licenses for academic,
              not for profit and commercial users.
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://zfin.org">
                ZFIN
              </Link>
            </Td>
            <Td>Zebrafish research</Td>
            <Td>
              <Link
                isExternal
                href="https://wiki.zfin.org/display/general/WARRANTY+AND+LIABILITY+DISCLAIMER%2C+OWNERSHIP%2C+AND+LIMITS+ON+USE"
              >
                WARRANTY AND LIABILITY DISCLAIMER, OWNERSHIP, AND LIMITS ON USE
              </Link>
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://pombase.org">
                PomBase
              </Link>
            </Td>
            <Td>
              <i>Schizosaccharomyces</i> research
            </Td>
            <Td>
              All data curated by PomBase, including data from Canto community
              curation, are licensed under the Creative Commons Attribution 4.0
              International license (CC-BY; see the Creative Commons site for a{" "}
              <Link
                isExternal
                href="https://creativecommons.org/licenses/by/4.0/"
              >
                summary
              </Link>{" "}
              and the{" "}
              <Link
                isExternal
                href="https://creativecommons.org/licenses/by/4.0/legalcode"
              >
                full license
              </Link>
              ).
              <br />
              Datasets hosted in the genome browser and front-page Research
              Spotlight images are used with permission of the generating
              researchers. Specific copyright and licensing terms may apply;
              consult the relevant publications (listed on the{" "}
              <Link
                isExternal
                href="https://www.pombase.org/about/data-sources"
              >
                Data Sources
              </Link>{" "}
              page) for details.
              <br />
              Canto is is licensed under the GNU General Public License v3.0;
              see the{" "}
              <Link
                isExternal
                href="https://github.com/pombase/canto/blob/master/LICENSE"
              >
                Canto License page
              </Link>{" "}
              for more information.
              <br />
              Also see the{" "}
              <Link
                isExternal
                href="https://www.pombase.org/about/citing-pombase"
              >
                Citing PomBase
              </Link>{" "}
              page.
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://maizegdb.org">
                MaizeGDB
              </Link>
            </Td>
            <Td>Maize research</Td>
            <Td>
              MaizeGDB is a public database, and all data curated by MaizeGDB
              are used with permission of the generating researchers and
              licensed under the Creative Commons Attribution 4.0 International
              license (CC-BY; see the Creative Commons site for a{" "}
              <Link
                isExternal
                href="https://creativecommons.org/licenses/by/4.0/"
              >
                summary
              </Link>{" "}
              and the{" "}
              <Link
                isExternal
                href="https://creativecommons.org/licenses/by/4.0/legalcode"
              >
                full license
              </Link>
              ), unless otherwise specified.
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="http://dictybase.org/">
                dictyBase
              </Link>
            </Td>
            <Td>
              <i>Dictyostelium</i> research
            </Td>
            <Td>
              The Dicty Community Resource (2002-2022; dictyBase and the Dicty
              Stock Center) is a database whose goal is to enable resource
              sharing among members of the Dictyostelium research community. All
              information, materials and the underlying code of DCR
              infrastructure are freely available to the broad research and
              education community via the{" "}
              <Link isExternal href="https://dictycr.org">
                DCR hub
              </Link>{" "}
              and our{" "}
              <Link isExternal href="https://github.com/dictyBase/">
                GitHub repositories
              </Link>
              . For the purposes of resource sharing, DCR adheres and subscribes
              to FAIR principles for being Findable, Accessible, Interoperable,
              and Reusable. To implement these resource sharing principles, DCR
              has applied various features of FAIR using a variety of
              technologies, for example, the DCR is a publicly available
              resource, accessible for all worldwide (F and A) and DCR records
              are linked to multiple databases such as Gene Ontology, ENA,
              UniProt, PubMed (I). The data sharing policy of DCR also adheres
              to FAIR principles for scientific data management. DCR
              infrastructure is powered by containerized software that runs in a
              cloud environment. Our software is released under the open source{" "}
              <Link
                isExternal
                href="https://opensource.org/licenses/BSD-2-Clause"
              >
                BSD 2-Clause license
              </Link>
              . The source code of all DCR software is open source and publicly
              available on GitHub.
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://solgenomics.net/">
                Sol Genomics
              </Link>
            </Td>
            <Td>
              <i>Solanaceae</i> research
            </Td>
            <Td>
              Data and information released from the Sol Genomics Network (SGN)
              are provided on an "AS IS" basis, without warranty of any kind,
              including without limitation the warranties of merchantability,
              fitness for a particular purpose and non-infringement.
              Availability of this data and information does not constitute
              scientific publication. Data and/or information may contain errors
              or be incomplete. Full information here{" "}
              <Link isExternal href="https://solgenomics.net/legal.pl">
                BSD 2-Clause licensehttps://solgenomics.net/legal.pl
              </Link>
              .
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="http://www.informatics.jax.org/">
                Mouse Genome informatics
              </Link>
            </Td>
            <Td>Mouse research</Td>
            <Td>
              MGI Warranty disclaimer and Copyright information can be accessed{" "}
              <Link
                isExternal
                href="http://www.informatics.jax.org/mgihome/other/copyright.shtml"
              >
                here
              </Link>
              .
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Link isExternal href="https://rgd.mcw.edu">
                RGD
              </Link>
            </Td>
            <Td>Rat research</Td>
            <Td>
              The Rat Genome Database is copyright © 2000-2024 Medical College
              of Wisconsin and is licensed under the{" "}
              <Link
                isExternal
                href="https://creativecommons.org/licenses/by/4.0/legalcode"
              >
                Creative Commons Attribution 4.0 International license
              </Link>{" "}
              (CC-BY 4.0). RGD tools and software are made available under the{" "}
              <Link
                isExternal
                href="https://github.com/rat-genome-database/rgd-core-library?tab=GPL-3.0-1-ov-file#readme"
              >
                GNU General Public License v3.0
              </Link>{" "}
              (GPL-3.0). For more information, see the RGD{" "}
              <Link isExternal href="https://rgd.mcw.edu/wg/disclaimer/">
                Legal Disclaimer
              </Link>{" "}
              and{" "}
              <Link isExternal href="https://rgd.mcw.edu/wg/citing-rgd/">
                Citing RGD
              </Link>{" "}
              pages.
            </Td>
          </Tr>
        </Tbody>
      </Table>
    ),
  },
];

const DataSection = (props) => {
  const { dataRef, isPage } = props;

  return (
    <Section
      items={items}
      title="Data Sharing Policy"
      sectionRef={dataRef}
      isPage={isPage}
    />
  );
};

export default DataSection;
